import { render, staticRenderFns } from "./DivisionDelete.vue?vue&type=template&id=3ba47eca"
import script from "./DivisionDelete.vue?vue&type=script&lang=js"
export * from "./DivisionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports